<template>
    <div class="main">

        <c-panel title="Filtros" titleIcon="fa fa-filter">

          <!-- O <el-form-item> DEPENDE DO CONTEXTO INJETADO PELO <el-form>; SEM ELE A TELA NÃO RENDERIZA -->
          <el-form label-position="top">

            <!-- NTI/SMED NÃO SÃO VINCULADOS A UMA INSTITUIÇÃO: PARA ELES A ESCOLHA É AQUI.
                 OS DEMAIS JÁ TRABALHAM SOBRE A INSTITUIÇÃO ATIVA DO CABEÇALHO. -->
            <el-row :gutter="10" v-if="precisaSelecionarInstituicao">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Instituição">
                        <el-select v-model="filtro.instituicao_id" filterable placeholder="Pesquisar instituição" @change="onChangeInstituicao" style="width: 100%;">
                            <el-option v-for="item in instituicoesOrdenadas" :key="item.id" :label="item.nome" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-alert v-if="!instituicaoId && !precisaSelecionarInstituicao" type="info" show-icon :closable="false"
                      title="Nenhuma instituição selecionada"
                      description="Esta tela trabalha sobre a instituição ativa. Selecione uma instituição para lançar notas.">
            </el-alert>

            <el-row :gutter="10" v-else>

                <el-col :xs="24" :sm="24" :md="10">
                    <el-form-item label="Turma">
                        <el-select v-model="filtro.turma_id" filterable placeholder="Selecione a turma" @change="onChangeTurma" style="width: 100%;">
                            <el-option-group v-for="grupo in turmasPorCurso" :key="grupo.curso" :label="grupo.curso">
                                <el-option v-for="item in grupo.turmas" :key="item.id" :label="item.nome" :value="item.id">
                                    <!-- ESTILO INLINE: O DROPDOWN DO ELEMENT É ANEXADO AO body E O CSS scoped NÃO ALCANÇA -->
                                    <span style="float: left;">{{ item.nome }}</span>
                                    <span style="float: right; color: #909399; font-size: 11px; margin-left: 20px;">{{ item.metodo_avaliacao == 'quantitativo' ? 'NOTA' : 'CONCEITO' }}</span>
                                </el-option>
                            </el-option-group>
                        </el-select>
                    </el-form-item>
                </el-col>

                <!-- PARECER NÃO É POR DISCIPLINA: EM TURMA QUALITATIVA O FILTRO SAI DA TELA -->
                <el-col :xs="24" :sm="12" :md="8" v-if="!turmaQualitativa">
                    <el-form-item label="Disciplina">
                        <el-select v-model="filtro.disciplina" filterable placeholder="Selecione a disciplina" :disabled="!filtro.turma_id" @change="carregar" style="width: 100%;">
                            <el-option v-for="item in disciplinasDaTurma" :key="item.id" :label="item.nome_area" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="turmaQualitativa ? 14 : 6">
                    <el-form-item label="Período">
                        <el-select v-model="filtro.periodo_diario" placeholder="Selecione o período" :disabled="!filtro.turma_id" @change="carregar" style="width: 100%;">
                            <el-option v-for="item in periodosDaTurma" :key="item.valor" :label="item.nome" :value="item.valor" :disabled="!item.aberto"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

            </el-row>

            <el-row :gutter="10" v-if="instituicaoId">
                <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                    <el-button @click="limpar">Limpar</el-button>
                </el-col>
            </el-row>

          </el-form>

        </c-panel>

        <c-panel v-if="carregado || loading" :title="tituloPainel" titleIcon="fa fa-list-ol">

            <div v-if="loading" class="u-text-center u-mt-20 u-mb-20">Carregando...</div>

            <template v-else>

                <el-alert v-if="diarioBloqueado" type="warning" show-icon :closable="false"
                          :title="motivoBloqueio" description="Os lançamentos abaixo são exibidos apenas para consulta.">
                </el-alert>

                <!-- TURMA QUALITATIVA: LISTA DE ALUNOS COM O PARECER DO PERÍODO -->
                <div v-if="turmaQualitativa" class="lista-parecer">

                    <div v-for="(aluno, i) in alunos" :key="aluno.nota_id" class="linha-parecer">

                        <div class="dados-aluno">
                            <h4>
                                {{ aluno.nome_social_aluno ? aluno.nome_social_aluno : aluno.nome }}
                                <span v-if="sufixoTransferencia(aluno)" class="tag-transferido">{{ sufixoTransferencia(aluno) }}</span>
                            </h4>
                            <span class="sub">Dt. Nascimento: {{ $moment(aluno.data_nascimento).format('DD/MM/YYYY') }}</span>
                            <span class="sub situacao" :class="{ preenchido: temParecer(aluno) }">
                                {{ temParecer(aluno) ? 'Parecer lançado' : 'Sem parecer' }}
                            </span>
                        </div>

                        <el-button type="primary" size="mini" icon="el-icon-edit" @click="abrirParecer(i)"></el-button>
                    </div>

                    <p v-if="alunos.length == 0" class="u-text-center">Nenhum aluno enturmado.</p>
                </div>

                <template v-if="!turmaQualitativa">

                    <div class="u-text-right u-mb-10" v-if="!diarioBloqueado">
                        <el-button size="mini" icon="el-icon-plus" @click="adicionarAtividade">ATIVIDADE</el-button>
                    </div>

                    <div class="tabela-lancamento">
                        <table>
                            <thead>
                                <tr>
                                    <th class="col-ordem">Nº</th>
                                    <th class="col-aluno">Aluno</th>
                                    <th v-for="item in avaliacoes" :key="item.id" class="col-nota">
                                        <span v-if="!diarioBloqueado" class="btn-excluir-atividade" title="Excluir atividade" @click="excluirAtividade(item.id)">&times;</span>
                                        {{ item.descricao }}
                                    </th>
                                    <th class="col-nota">Somatória</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(aluno, i) in alunos" :key="aluno.nota_id">
                                    <td class="col-ordem">{{ i + 1 }}</td>
                                    <td class="col-aluno">
                                        {{ aluno.nome_social_aluno ? aluno.nome_social_aluno : aluno.nome }}
                                        <span v-if="sufixoTransferencia(aluno)" class="tag-transferido">{{ sufixoTransferencia(aluno) }}</span>
                                    </td>
                                    <td v-for="item in avaliacoes" :key="item.id" class="col-nota">
                                        <nota-input v-model="aluno.atividades[item.id].v"
                                                    :nota-maxima="maxPermitido(aluno, item.id)"
                                                    :teto="NOTA_MAXIMA_PERIODO"
                                                    :disabled="diarioBloqueado"
                                                    @alert-maximo="alertaMaximo(aluno, $event)">
                                        </nota-input>
                                    </td>
                                    <td class="col-nota col-somatoria" :class="{ 'soma-excedida': somatoria(aluno) > NOTA_MAXIMA_PERIODO }">
                                        {{ somatoriaTexto(aluno) }}
                                    </td>
                                </tr>
                                <tr v-if="alunos.length == 0">
                                    <td :colspan="avaliacoes.length + 3" class="u-text-center">Nenhum aluno enturmado.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="u-text-right u-mt-20" v-if="!diarioBloqueado && alunos.length > 0">
                        <el-button type="primary" @click="salvar">SALVAR</el-button>
                    </div>

                </template>

            </template>

        </c-panel>

        <el-dialog :close-on-click-modal="false" :title="tituloParecer" width="60%" top="40px"
                   :visible.sync="dialogParecer" append-to-body>

            <div v-if="dialogParecer" class="u-mt-20">

                <el-form label-position="top" @submit.native.prevent="salvarParecer">

                    <el-form-item label="Parecer">
                        <el-input type="textarea" :rows="14" v-model="parecerTexto" :disabled="diarioBloqueado"></el-input>
                    </el-form-item>

                    <i class="aviso-log">Atenção: Para fins de rastreabilidade, será criado um log associando o seu usuário ao cadastro deste parecer.</i>

                    <div class="u-text-right u-mt-15">
                        <el-button @click="dialogParecer = false">FECHAR</el-button>
                        <el-button type="primary" native-type="submit" v-if="!diarioBloqueado">SALVAR</el-button>
                    </div>

                </el-form>
            </div>

        </el-dialog>

    </div>
</template>

<script>
import NotaInput from '@/shared/nota-input/nota-input.vue'

export default {
    name: 'LancamentoNota',

    components: { 'nota-input': NotaInput },

    data(){

        return {

            //LIMITE DA SOMA DAS ATIVIDADES DE UM PERÍODO, IGUAL AO DO BACKEND (Helper::NOTA_MAXIMA_PERIODO)
            NOTA_MAXIMA_PERIODO: 10,

            dados: { turmas: [], disciplinas: [], parametros_diario: [] },
            filtro: { instituicao_id: '', turma_id: '', disciplina: '', periodo_diario: '' },
            avaliacoes: [],
            alunos: [],
            loading: false,
            carregado: false,
            tituloPainel: '',
            dialogParecer: false,
            alunoParecer: null,
            parecerTexto: ''
        }
    },

    computed: {

        //MESMO CRITÉRIO USADO NA TELA DE DIÁRIO: ESSES TIPOS NÃO SÃO VINCULADOS A INSTITUIÇÃO
        precisaSelecionarInstituicao(){

            let tipo = Number(this.$store.state.user.tipo);

            return (tipo > 3 && tipo <= 8) || tipo == 10;
        },

        //A API DEVOLVE AS INSTITUIÇÕES COMO OBJETO INDEXADO PELO id, NÃO COMO ARRAY
        instituicoesOrdenadas(){

            return Object.values(this.$store.state.instituicoes || {})
                        .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
        },

        instituicaoId(){

            if(this.precisaSelecionarInstituicao)
                return this.filtro.instituicao_id || null;

            return this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null;
        },

        ehDocente(){

            return Number(this.$store.state.user.tipo) === 2;
        },

        //O DOCENTE SÓ ENXERGA AS TURMAS EM QUE ESTÁ ENTURMADO; OS DEMAIS VEEM TODAS
        turmasOrdenadas(){

            let lista = this.ehDocente
                            ? this.dados.turmas.filter(t => t.minha_turma)
                            : this.dados.turmas;

            return lista.slice().sort((a, b) => {

                let na = `${a.curso ? a.curso.nome : ''} ${a.nome}`;
                let nb = `${b.curso ? b.curso.nome : ''} ${b.nome}`;

                return na.localeCompare(nb, 'pt-BR');
            });
        },

        //AGRUPA AS TURMAS POR CURSO PARA O <el-option-group>. A LISTA JÁ VEM ORDENADA
        //POR CURSO E DEPOIS POR TURMA, ENTÃO BASTA QUEBRAR QUANDO O CURSO MUDA.
        turmasPorCurso(){

            let grupos = [];
            let indice = {};

            for(let i in this.turmasOrdenadas){

                let turma = this.turmasOrdenadas[i];
                let curso = turma.curso && turma.curso.nome ? turma.curso.nome : 'SEM CURSO';

                if(typeof indice[curso] === 'undefined'){

                    indice[curso] = grupos.length;
                    grupos.push({ curso: curso, turmas: [] });
                }

                grupos[indice[curso]].turmas.push(turma);
            }

            return grupos;
        },

        turmaQualitativa(){

            return !!this.turmaSelecionada && this.turmaSelecionada.metodo_avaliacao != 'quantitativo';
        },

        tituloParecer(){

            if(this.alunoParecer === null || !this.alunos[this.alunoParecer])
                return 'PARECER';

            let aluno = this.alunos[this.alunoParecer];
            let nome = aluno.nome_social_aluno ? aluno.nome_social_aluno : aluno.nome;

            return `PARECER - ${nome}`;
        },

        turmaSelecionada(){

            return this.dados.turmas.find(t => t.id == this.filtro.turma_id);
        },

        //DOCENTE VÊ SÓ AS DISCIPLINAS EM QUE FOI ENTURMADO NAQUELA TURMA (turma.disciplinas);
        //OS DEMAIS VEEM TODAS AS DISCIPLINAS DA TURMA
        disciplinasDaTurma(){

            if(!this.turmaSelecionada)
                return [];

            let ids = this.ehDocente
                        ? (this.turmaSelecionada.disciplinas || []).map(d => Number(d.id ? d.id : d))
                        : []
                            .concat(this.turmaSelecionada.areas_cobhecimento_principais || [])
                            .concat(this.turmaSelecionada.areas_cobhecimento_diversificadas || [])
                            .map(Number);

            return this.dados.disciplinas
                        .filter(d => ids.includes(Number(d.id)))
                        .sort((a, b) => a.nome_area.localeCompare(b.nome_area, 'pt-BR'));
        },

        //parametros_diario TRAZ OS ÍNDICES LIBERADOS COMEÇANDO EM ZERO; A API ESPERA O PERÍODO COMEÇANDO EM UM
        periodosDaTurma(){

            if(!this.turmaSelecionada || !this.turmaSelecionada.periodos_diario)
                return [];

            return this.turmaSelecionada.periodos_diario.map((nome, i) => {

                return {
                    nome: nome,
                    valor: i + 1,
                    aberto: this.dados.parametros_diario.includes(String(i))
                };
            });
        },

        filtroCompleto(){

            if(!this.instituicaoId || !this.filtro.turma_id || !this.filtro.periodo_diario)
                return false;

            //PARECER NÃO É POR DISCIPLINA
            return this.turmaQualitativa ? true : !!this.filtro.disciplina;
        },

        //APÓS O CONSELHO DE CLASSE PARCIAL O DIÁRIO NÃO ACEITA MAIS LANÇAMENTO
        diarioBloqueado(){

            return !!this.turmaSelecionada && this.turmaSelecionada.fase_diario >= 3;
        },

        motivoBloqueio(){

            if(this.turmaSelecionada && this.turmaSelecionada.fase_diario == 5)
                return 'O diário desta turma já foi encerrado.';

            return 'O Conselho de Classe Parcial desta turma já foi encerrado.';
        },

        tituloLancamento(){

            let periodo = this.periodosDaTurma.find(p => p.valor == this.filtro.periodo_diario);
            let nomePeriodo = periodo ? periodo.nome : '';

            //SEM DISCIPLINA EM TURMA QUALITATIVA: O PARECER É DO PERÍODO
            if(this.turmaQualitativa)
                return `PARECER - ${nomePeriodo}`;

            let disciplina = this.dados.disciplinas.find(d => d.id == this.filtro.disciplina);

            return `${disciplina ? disciplina.nome_area : ''} - ${nomePeriodo}`;
        }
    },

    mounted(){

        this.init();
    },

    methods: {

        init(){

            if(!this.instituicaoId)
                return;

            window.eventBus.$emit('loading', true);

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/nota/initFormNotas/${this.instituicaoId}`, this.$store.getters.getHeaderAuth).then(response => {

                this.dados = JSON.parse(JSON.stringify(response.data));
                window.eventBus.$emit('loading', false);

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },

        onChangeInstituicao(){

            this.dados = { turmas: [], disciplinas: [], parametros_diario: [] };
            this.onChangeTurma();
            this.filtro.turma_id = '';

            this.init();
        },

        onChangeTurma(){

            this.filtro.disciplina = '';
            this.filtro.periodo_diario = '';
            this.limparResultado();
        },

        //A GRADE SÓ APARECE AO CLICAR EM BUSCAR; MUDAR UM FILTRO DESCARTA O RESULTADO
        //ANTERIOR PARA NÃO EXIBIR DADO DE OUTRA TURMA/DISCIPLINA.
        limparResultado(){

            this.avaliacoes = [];
            this.alunos = [];
            this.carregado = false;
        },

        limpar(){

            this.filtro.turma_id = '';
            this.filtro.disciplina = '';
            this.filtro.periodo_diario = '';
            this.limparResultado();
        },

        //DISPARA SOZINHO QUANDO OS TRÊS FILTROS ESTÃO PREENCHIDOS
        carregar(){

            if(!this.filtroCompleto){

                this.limparResultado();
                return;
            }

            this.tituloPainel = this.tituloLancamento;
            this.carregado = true;
            this.avaliacoes = [];
            this.alunos = [];

            this.loading = true;

            //TURMA QUALITATIVA NÃO TEM ATIVIDADE: VAI DIRETO PARA A LISTA DE ALUNOS
            if(this.turmaQualitativa){

                this.carregarAlunos();
                return;
            }

            //O BACKEND CRIA AS ATIVIDADES PADRÃO NA PRIMEIRA VEZ QUE A COMBINAÇÃO É ABERTA
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/avaliacao/init`, {
                turma_id: this.filtro.turma_id,
                area_conhecimento_id: this.filtro.disciplina,
                periodo_diario: this.filtro.periodo_diario
            }, this.$store.getters.getHeaderAuth).then(response => {

                if(response.data && response.data.erro){

                    this.loading = false;
                    window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                    return;
                }

                this.avaliacoes = Array.isArray(response.data) ? response.data : [];

                this.carregarAlunos();

            }).catch((error) => { this.loading = false; this.$store.commit('throwException', error); });
        },

        carregarAlunos(){

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/getAlunosForFormNotaAllAvaliacao`, {
                turma_id: this.filtro.turma_id,
                periodo_diario: this.filtro.periodo_diario,
                //PRECISA SER null, NÃO '': A COLUNA É INTEIRA E STRING VAZIA DERRUBA A QUERY
                disciplina: this.filtro.disciplina ? this.filtro.disciplina : null,
                avaliacao_id: ''
            }, this.$store.getters.getHeaderAuth).then(response => {

                let lista = JSON.parse(JSON.stringify(response.data));

                //O ALUNO PODE NÃO TER A CHAVE DE UMA ATIVIDADE NO JSON DELE. SEM CRIAR A CHAVE
                //AQUI, O v-model NÃO TEM ONDE ESCREVER E O INPUT FICA MORTO.
                for(let i in lista){

                    if(!lista[i].atividades)
                        this.$set(lista[i], 'atividades', {});

                    for(let j in this.avaliacoes){

                        let id = this.avaliacoes[j].id;

                        if(!lista[i].atividades[id])
                            this.$set(lista[i].atividades, id, { u: '', v: '' });
                    }
                }

                this.alunos = lista;
                this.loading = false;

            }).catch((error) => { this.loading = false; this.$store.commit('throwException', error); });
        },

        recarregar(){

            this.carregar();
        },

        converte(valor){

            if(valor === '' || valor === null || typeof valor === 'undefined')
                return null;

            let n = parseFloat(String(valor).replace(',', '.'));

            return isNaN(n) ? null : n;
        },

        somatoria(aluno){

            let soma = 0;

            for(let j in this.avaliacoes){

                let item = aluno.atividades[this.avaliacoes[j].id];
                let n = item ? this.converte(item.v) : null;

                if(n !== null)
                    soma += n;
            }

            return Math.round(soma * 100) / 100;
        },

        //SEMPRE COM DUAS CASAS, IGUAL AOS CAMPOS DE NOTA
        formataNumero(n){

            if(n === '' || n === null || typeof n === 'undefined')
                return '';

            let x = Number(n);

            if(isNaN(x))
                return '';

            return x.toFixed(2).replace('.', ',');
        },

        //LINHA SEM NENHUMA NOTA FICA COM A SOMATÓRIA EM BRANCO, NÃO COM 0,00
        somatoriaTexto(aluno){

            for(let j in this.avaliacoes){

                let item = aluno.atividades[this.avaliacoes[j].id];

                if(item && this.converte(item.v) !== null)
                    return this.formataNumero(this.somatoria(aluno));
            }

            return '';
        },

        //QUANTO AINDA CABE NESTA CÉLULA SEM A LINHA DO ALUNO PASSAR DE 10 PONTOS.
        //O BACKEND REJEITA A REQUISIÇÃO INTEIRA SE A SOMA ESTOURAR, ENTÃO O CAMPO
        //NEM DEIXA DIGITAR ALÉM DISSO.
        maxPermitido(aluno, avaliacaoId){

            let soma = 0;

            for(let j in this.avaliacoes){

                let id = this.avaliacoes[j].id;

                if(String(id) === String(avaliacaoId))
                    continue;

                let item = aluno.atividades[id];
                let n = item ? this.converte(item.v) : null;

                if(n !== null)
                    soma += n;
            }

            let restante = Math.round((this.NOTA_MAXIMA_PERIODO - soma) * 100) / 100;

            return restante < 0 ? 0 : restante;
        },

        alertaMaximo(aluno, limite){

            let nome = aluno.nome_social_aluno ? aluno.nome_social_aluno : aluno.nome;

            let msg = limite >= this.NOTA_MAXIMA_PERIODO
                        ? `A nota não pode ser superior a ${this.NOTA_MAXIMA_PERIODO}.`
                        : `A soma das notas do período não pode ultrapassar ${this.NOTA_MAXIMA_PERIODO} pontos. Para ${nome}, o máximo nesta atividade é ${this.formataNumero(limite)}.`;

            //TOAST, NÃO MODAL: O DIÁLOGO ROUBA O FOCO DO INPUT NO MEIO DA DIGITAÇÃO
            window.eventBus.$emit('alert', {msg: msg, type: 'warning'});
        },

        //O PARECER VEM DA API COMO OBJETO INDEXADO PELO PERÍODO: { "1": "...", "2": "", "3": "" }
        temParecer(aluno){

            if(!aluno.parecer)
                return false;

            let texto = aluno.parecer[this.filtro.periodo_diario];

            return !!texto && String(texto).trim() !== '';
        },

        abrirParecer(i){

            this.alunoParecer = i;

            let aluno = this.alunos[i];
            let texto = aluno.parecer ? aluno.parecer[this.filtro.periodo_diario] : '';

            this.parecerTexto = texto ? texto : '';
            this.dialogParecer = true;
        },

        salvarParecer(){

            if(this.alunoParecer === null)
                return;

            let aluno = JSON.parse(JSON.stringify(this.alunos[this.alunoParecer]));

            if(!aluno.parecer)
                aluno.parecer = {};

            aluno.parecer[this.filtro.periodo_diario] = this.parecerTexto;

            window.eventBus.$emit('loading', true);

            //O storeParecer GRAVA O MAPA INTEIRO DE PERÍODOS, ENTÃO VAI O ALUNO COMPLETO
            let payload = {
                turma: this.filtro.turma_id,
                disciplina: null,
                periodo_diario: this.filtro.periodo_diario,
                avaliacao: '',
                alunos: [aluno]
            };

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/nota/storeParecer`, payload, this.$store.getters.getHeaderAuth).then(response => {

                window.eventBus.$emit('loading', false);

                let msg = response.data ? (response.data.erro || response.data.error) : null;

                if(msg){

                    window.eventBus.$emit('alert', {msg: msg, type: 'warning'});
                    return;
                }

                //ATUALIZA NA TELA SEM RECARREGAR A TURMA INTEIRA
                this.$set(this.alunos[this.alunoParecer], 'parecer', aluno.parecer);

                window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                this.dialogParecer = false;

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },

        sufixoTransferencia(aluno){

            if(!aluno || !aluno.ultima_transferencia)
                return '';

            return `(transferido em: ${this.$moment(aluno.ultima_transferencia).format('DD/MM/YYYY')})`;
        },

        adicionarAtividade(){

            window.eventBus.$emit('loading', true);

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/avaliacao/store`, {
                turma_id: this.filtro.turma_id,
                area_conhecimento_id: this.filtro.disciplina,
                periodo_diario: this.filtro.periodo_diario
            }, this.$store.getters.getHeaderAuth).then(response => {

                window.eventBus.$emit('loading', false);

                if(response.data && response.data.erro){

                    window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                    return;
                }

                window.eventBus.$emit('alert', {msg: 'Atividade adicionada!', type: 'success'});
                this.recarregar();

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },

        excluirAtividade(avaliacaoId){

            this.$confirm('Deseja excluir esta atividade?', 'Atenção', {
                confirmButtonText: 'Excluir',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/avaliacao/remover/${avaliacaoId}`, {}, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);

                    if(response.data && response.data.erro){

                        window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                        return;
                    }

                    window.eventBus.$emit('alert', {msg: 'Atividade excluída!', type: 'success'});
                    this.recarregar();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(() => {});
        },

        salvar(){

            //TRAVA LOCAL ANTES DE MANDAR: O BACKEND RECUSA A REQUISIÇÃO INTEIRA SE UM ALUNO PASSAR DE 10
            let excedentes = this.alunos
                                .filter(a => this.somatoria(a) > this.NOTA_MAXIMA_PERIODO)
                                .map(a => `${a.nome_social_aluno ? a.nome_social_aluno : a.nome} (${this.formataNumero(this.somatoria(a))})`);

            if(excedentes.length > 0){

                this.$alert(
                    `A soma das notas do período não pode ultrapassar ${this.NOTA_MAXIMA_PERIODO} pontos. Verifique: ${excedentes.join('; ')}.`,
                    'Atenção',
                    { confirmButtonText: 'OK' }
                );

                return;
            }

            window.eventBus.$emit('loading', true);

            let payload = {
                turma: this.filtro.turma_id,
                disciplina: this.filtro.disciplina,
                periodo_diario: this.filtro.periodo_diario,
                avaliacao: '',
                alunos: JSON.parse(JSON.stringify(this.alunos))
            };

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/nota/storeNota`, payload, this.$store.getters.getHeaderAuth).then(response => {

                window.eventBus.$emit('loading', false);

                //O BACKEND DEVOLVE 'erro' EM UMAS ROTINAS E 'error' EM OUTRAS
                let msg = response.data ? (response.data.erro || response.data.error) : null;

                if(msg){

                    window.eventBus.$emit('alert', {msg: msg, type: 'warning'});
                    return;
                }

                window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                this.recarregar();

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        }
    }
}
</script>

<style scoped>

.tabela-lancamento {
    overflow-x: auto;
}

.tabela-lancamento table {
    width: 100%;
    border-collapse: collapse;
}

.tabela-lancamento th,
.tabela-lancamento td {
    border: 1px solid #e4e7ed;
    padding: 7px 10px;
    font-size: 13px;
}

/* MESMO AZUL DA BORDA DO c-panel, PARA A TABELA NÃO DESTOAR DO RESTO DO PAINEL */
.tabela-lancamento thead th {
    background: #427896;
    color: #fff;
    border-color: #427896;
    font-weight: 600;
    text-align: center;
    position: relative;
}

.tabela-lancamento .col-ordem {
    width: 50px;
    text-align: center;
    color: #909399;
}

.tabela-lancamento thead .col-ordem {
    color: #fff;
}

.tabela-lancamento .col-aluno {
    text-align: left;
    min-width: 260px;
}

.tabela-lancamento .col-nota {
    width: 110px;
    text-align: center;
}

/* O INPUT DO PROJETO VEM SÓ COM A LINHA DE BAIXO; AQUI ELE PRECISA DE CAIXA */
.tabela-lancamento >>> .el-input__inner {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    text-align: center;
    padding: 0 6px;
    height: 30px;
    line-height: 30px;
    background: #fff;
}

.tabela-lancamento >>> .el-input.is-disabled .el-input__inner {
    background: #f5f7fa;
}

.tabela-lancamento .col-somatoria {
    font-weight: 600;
    background: #fafafa;
}

.tabela-lancamento .soma-excedida {
    color: #f56c6c;
}

.tabela-lancamento tbody tr:hover td {
    background: #f5f7fa;
}

.btn-excluir-atividade {
    position: absolute;
    top: 1px;
    right: 4px;
    cursor: pointer;
    color: #c0c4cc;
    font-size: 15px;
    line-height: 1;
}

.btn-excluir-atividade:hover {
    color: #f56c6c;
}

.tag-transferido {
    color: #e6a23c;
    font-size: 11px;
}

.lista-parecer .linha-parecer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ebeef5;
    padding: 10px 4px;
}

.lista-parecer .linha-parecer:hover {
    background: #f5f7fa;
}

.lista-parecer h4 {
    margin: 0 0 4px 0;
    font-size: 14px;
    font-weight: 500;
}

.lista-parecer .sub {
    font-size: 12px;
    color: #909399;
    margin-right: 14px;
}

.lista-parecer .situacao {
    color: #e6a23c;
}

.lista-parecer .situacao.preenchido {
    color: #67c23a;
}

.aviso-log {
    font-size: 12px;
    color: #909399;
}

</style>
